module.exports = __webpack_public_path__ + "img/sad.3ef9f366.svg";